//funcion sumar totales
export function sumarTotales(arrayObjetos) {
  const total = arrayObjetos.reduce((acumulador, objetoActual) => {
    return acumulador + objetoActual.total;
  }, 0);

  return total;
}
